@for (item of scanViewData(); track item.scan.id) {
  <div data-cy="scandata-tree-item">
    <div class="flex flex-row min-h-[32px] text-sm cursor-pointer hover:bg-gray-0">
      <sd-scandata-tree-icon
        class="flex items-center cursor-default pl-[10px] min-w-[38px] max-w-[38px]"
        data-cy="pointcloud-visibility-icon"
        [treeIcon]="item.icon"
        [disabled]="item.loadDisabled"
        (clicked)="modelIconClicked(item.scan)"
      ></sd-scandata-tree-icon>
      <div
        role="button"
        tabindex="0"
        modus-tooltip="{{ item.scan.name }}"
        tooltipClass="break-anywhere !whitespace-pre-wrap"
        class="flex items-center w-full overflow-hidden p-1"
        (click)="modelNameClicked(item.scan)"
        (keyup.enter)="modelNameClicked(item.scan)"
      >
        <div
          class="block w-full overflow-hidden text-ellipsis whitespace-nowrap"
          [ngClass]="{
            'text-red': item.hasError,
            'text-gray-6': item.notReady,
          }"
        >
          {{ item.scan.name }}
          <div class="text-small italic text-gray-6">{{ item.infoMessage }}</div>
        </div>

        @if (item.version) {
          <modus-badge class="ml-2 w-10 text-center" type="counter" color="tertiary">{{
            item.version
          }}</modus-badge>
        }
      </div>

      <div class="flex flex-row items-center">
        @if (item.scan.numberOfStations > 0 && item.scan.expanded) {
          <md-icon class="!flex text-lg/5 h-full items-center" (click)="toggleExpand(item.scan)"
            >caret_down</md-icon
          >
        } @else if (item.scan.numberOfStations > 0 && !item.scan.expanded) {
          <md-icon class="!flex text-lg/5 h-full items-center" (click)="toggleExpand(item.scan)"
            >caret_right</md-icon
          >
        } @else {
          <span class="w-6"></span>
        }
        <sd-scandata-tree-menu
          [scan]="item.scan"
          [fitToViewDisabled]="item.fitToViewDisabled"
          [hasRotatePanoramasFeature]="hasRotatePanoramasFeature()"
          [rotatePanoramasDisabled]="item.rotatePanoramasDisabled"
          [stationHeadingOffsetDegrees]="item.stationHeadingOffsetDegrees"
          [hasViewInNumarkFeature]="item.hasViewInNumarkFeature"
          (modelDetailClick)="modelDetailClicked(item.scan)"
          (modelFitToViewClick)="modelFitToViewClicked(item.scan)"
          (modelRotatePanoramasClick)="modelRotatePanoramasClicked(item.scan)"
          (viewInNumarkClick)="modelViewInNumarkClicked(item.scan)"
        ></sd-scandata-tree-menu>
      </div>
    </div>

    @if (item.scan.numberOfStations > 0 && item.scan.expanded) {
      @if (item.stationsNotLoaded || item.hasViewInNumarkFeature) {
        <div class="text-small italic pt-2 pb-1 pl-10 pr-8 bg-yellow-pale">
          @if (item.stationsNotLoaded) {
            <div class="block">{{ stationsNotLoadedMessage }}</div>
          }
          @if (item.hasViewInNumarkFeature) {
            <a
              tabindex="0"
              class="-ml-2 inline-block font-semibold text-trimble-blue cursor-pointer hover:bg-gray-0"
              (click)="modelViewInNumarkClicked(item.scan)"
              (keyup.enter)="modelViewInNumarkClicked(item.scan)"
            >
              <div class="py-1 px-2">{{ translations.station.viewInNumark.text }}</div>
            </a>
          }
        </div>
      }
      <div class="cursor-pointer pl-8">
        @if (item.stationsLoading) {
          <div class="text-small italic py-1 pl-2">{{ translations.station.loading.text }}</div>
        }

        @for (stationItem of item.stations; track stationItem.station.id) {
          <div class="flex flex-row min-h-[32px] pl-1 items-center text-sm hover:bg-gray-0">
            <sd-scandata-tree-icon
              class="min-w-[28px] max-w-[28px]"
              data-cy="station-visibility-icon"
              [modus-tooltip]="stationDisabledReason()"
              [tooltipDisabled]="stationTooltipDisabled()"
              [treeIcon]="stationItem.icon"
              [disabled]="loadStationDisabled()"
              (clicked)="stationIconClicked(stationItem.station)"
            ></sd-scandata-tree-icon>
            <div
              role="button"
              tabindex="0"
              class="w-full overflow-hidden pl-1 py-1 pr-8"
              tooltipClass="break-anywhere !whitespace-pre-wrap"
              [modus-tooltip]="stationItem.tooltip"
              (click)="stationNameClicked(stationItem.station)"
              (keyup.enter)="stationNameClicked(stationItem.station)"
            >
              <div
                class="w-full overflow-hidden text-ellipsis whitespace-nowrap"
                [ngClass]="{ 'text-red': stationItem.hasError }"
              >
                {{ stationItem.displayName }}
              </div>
              <div class="w-full overflow-hidden text-ellipsis whitespace-nowrap text-small italic">
                {{ stationItem.errorMessage }}
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
}
